module.exports = "/_next/static/pages/test-guidelines/8f478fd857e87df35ed50ddd35601159.png";